import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import IPropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'

import {
    createXlsExportTask,
    createPdfExportTask,
} from '../../../../../../../components/EntityStack/components/StackContent/components/ExportsContent/actions'

import { BLOCK_TYPE } from './constants'

function mapStateToProps(state, hocProps) {
    const { module, id } = hocProps
    const activeReportType = state.getIn(['ui', 'modules', module, 'ribbon', 'reports', 'active'], null)

    const blocks = state.getIn(
        ['authorization', 'accessRights', module, 'custom', 'reports', activeReportType, 'blocks'],
        Map()
    )


    return {
        estatesType: blocks.getIn(['estates', 'parameters', 'type'], BLOCK_TYPE.BASIC),
        currentAddressRuianId: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', 'addresses', 'customData', 'activeAddress', 'ruianId'],
            null
        ),
        activeBlocks: state.getIn(['ui', 'modules', module, 'ribbon', 'reportBlocks', 'data']),
        alzaScoringCustomData: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'alzaScoring', 'customData']),
        privilegesTypeBlocks: state.getIn(
            ['authorization', 'accessRights', module, 'custom', 'reports', activeReportType, 'blocks'],
            Map()
        ),
        activeAccessRightTypes: state.getIn(['authorization', 'accessRights', module, 'custom', 'reports']),
        rolesInCompaniesOpenSections: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            'rolesInCompanies',
            'customData',
            'openSections',
        ]),
        fstmtLevel: state.getIn(['ui', 'workspace', module, id, 'blocks', 'fstmt', 'level'], undefined),
        fanalLevel: state.getIn(['ui', 'workspace', module, id, 'blocks', 'fanal', 'level'], undefined),
        standards: state.getIn([
            'ui',
            'modules',
            module,
            'workspace',
            id,
            'blocks',
            'fstmt',
            'data',
            'statements',
            'standard',
        ]),
        cashflow: state.getIn([
            'ui',
            'modules',
            module,
            'workspace',
            id,
            'blocks',
            'fstmt',
            'data',
            'statements',
            'cashFlow',
        ]),
        analysisType: state.getIn([
            'ui',
            'modules',
            module,
            'workspace',
            id,
            'blocks',
            'fanal',
            'data',
            'statementType',
        ]),
        fstmtCustomData: state.getIn(['ui', 'workspace', module, id, 'blocks', 'fstmt', 'customData']),
        fanalCustomData: state.getIn(['ui', 'workspace', module, id, 'blocks', 'fanal', 'customData']),
        financeTable: state.getIn(['financeTable', id]),
        distraintsHistory: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            'negativeEvents',
            'customData',
            'distraintsHistory',
        ]),
        googleMap: state.getIn(['ui', 'googleMap', id]),
        addressesActiveAddress: state.getIn([
            'ui',
            'workspace',
            'report',
            id,
            'blocks',
            'addresses',
            'customData',
            'activeAddress',
        ]),
        velikostCustomData: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'velikost', 'customData'], {}),
        ownershipToggledSections: state.getIn(
            ['ui', 'workspace', 'report', id, 'blocks', 'ownership', 'customData', 'toggledSections'],
            {}
        ),
        paymentComparisonShowChartDataTable: state.getIn(
            ['ui', 'workspace', 'report', id, 'blocks', 'paymentComparison', 'customData', 'showChartDataTable'],
            false
        ),

        bisnodeScoringCustomData: state.getIn([
            'ui',
            'workspace',
            'report',
            id,
            'blocks',
            'bisnodeScoring',
            'customData',
        ]),
        paymentIndexCustomData: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'paymentIndex', 'customData']),
        entityType: state.getIn(['ui', 'modules', 'report', 'workspace', id, 'entity', 'type'], null),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createXlsExportTask,
            createPdfExportTask,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            activeBlocks: IPropTypes.map,
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
